const now = () => performance.now();
export default now;
//# sourceMappingURL=Now.js.map